import { Component, OnInit } from '@angular/core';
import { LibraryService, Dropobj } from '../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-stockaudit',
  templateUrl: './stockaudit.component.html',
  styleUrls: ['./stockaudit.component.scss'],
  providers:[LibraryService]
})
export class StockauditComponent implements OnInit {
  arrlibtsah:any[]=[];
  bookdetails:any[]=[];
  issuedetails:any[]=[];
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  selitem:any={};
  selbook:any={};
  selmember:any={};
  dashcounts:any={};
  objstmhead:any={};
  objres:any={};
  objvisitcnt:any={};
  accno:any;
   value: Date;
   isLoadingResult: boolean;
   memno:any='';
   memexist: boolean=false;
   visitorexist: boolean=false;
   fserdt:any;
   fserdt4:any;
   hsaid:any;
   arrlibtsad:any=[];
   arrlibdup:any=[]
   arrlibtsar:any=[];
   acctypes:any=[];
   rsaid:any;
   location:any='';
   serchbook:any='';
   arrstatus:any=[{value:'All'},{value:'Missing'},{value:'Found'}];
   status='All';

   public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
        position: 'left',
      },
  };
  public pieChartLabels: Label[] ;
  public pieChartData: SingleDataSet ;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors: Color[] = [
    {backgroundColor:["#FF00CC","#0033FF","#99CC00","#FF3333","#FFFF66"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
  ];
  
  constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getheaderdetails();
  }

  getdatetoday() {
    this.liservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.objstmhead.sdt = resultArray;
            this.objstmhead.edt = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  booksverified()
{
  
  this.liservice.Getdashboarddata('booksverify')
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    

    //this.mutitest();
   // this.dataSource = new MatTableDataSource(resultArray);
   var arr = []
   var labelarr=[];


   for ( var i = 0; i < resultArray.length ; i++) {
    //console.log('multiarray -i',JSON.stringify(i));
     
          
    labelarr.push(resultArray[i].emnm);
         
    arr.push(parseInt( resultArray[i].vcount));    
         
  }
    
   
    this.pieChartLabels = labelarr;
   this.pieChartData = arr;
   
   console.log("pieChartData ", this.pieChartLabels);
    },
   error => console.log("Error :: " + error)
)
}
  opendlgheader(content,cmd,objdata) {
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      //  size:'md'
     
    }
if(cmd=='insert')
{
  
this.objstmhead={};
this.getdatetoday();
this.objstmhead.said=0;
this.objstmhead.sanm='';
this.objstmhead.rmk='';
this.objstmhead.oprtype='insert';



}

else if(cmd=='update')
{
  this.objstmhead=objdata;
  this.objstmhead.oprtype='update';

}


    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  opendlgresult(content,cmd,objdata) {
    this.getlibaccesiontype() ;
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      //  size:'md'
     
    }

  this.objres=objdata;
  this.objres.oprtype='update';




    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  opendupdlg(content) {
    this.getdupdetails() ;
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      //  size:'md'
     
    }


    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  onheaderchange()
  {}
  savelibtsah()
  {
console.log('objregdata',this.objstmhead);

this.liservice.savelibtsah(this.objstmhead)
.subscribe((result:any) => {

  alert (result.message);
console.log('arrinst',result);

if(result.status=='Success')
{
  let localmodref=this.modalRef;
  localmodref.close();
  this.getheaderdetails();

}
else
{

}
}, error => {


}
);
  
  }

  savelibtsad()
  {
    debugger
//console.log('objregdata',this.objstmhead);
if(this.accno!='')
{
var obj={accno:this.accno,said:this.hsaid,rid:0,location:this.location};
this.liservice.savelibtsad(obj)
.subscribe((result:any) => {

  alert (result.message);
console.log('arrinst',result);

if(result.status=='Success')
{
 this.accno='';
 //this.location='';
  this.getdetails();

}
else
{

}
}, error => {


}
);
}
  
  }

  getheaderdetails() {
    this.liservice.getlibtsah()
        .subscribe(
        resultArray => {
            console.log('arrlibtsah', resultArray);
            this.arrlibtsah = resultArray;
            this.hsaid=resultArray[0].said;
            this.rsaid=resultArray[0].said;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getdetails() {
    this.liservice.getlibtsad(this.hsaid,'select')
        .subscribe(
        resultArray => {
            console.log('arrlibtsah', resultArray);
            this.arrlibtsad = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getdupdetails() {
    this.liservice.getlibtsad(this.hsaid,'seldup')
        .subscribe(
        resultArray => {
            console.log('arrlibtsah', resultArray);
            this.arrlibdup = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  searchdetails() {
    this.liservice.serchlibtsad(this.hsaid,this.serchbook)
        .subscribe(
        resultArray => {
            console.log('arrlibtsah', resultArray);
            this.arrlibtsad = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  delduplibtsad() {
    if(confirm('Are you sure you want to delete..?'))
    {
    this.liservice.delduplibtsad(this.hsaid)
        .subscribe(
        resultArray => {
            console.log('arrlibtsah', resultArray);
            //this.arrlibtsad = resultArray;
            alert(resultArray.message);
            this.getdetails();
            this.getdupdetails();
           
        },
        error => console.log("Error :: " + error)
        )
    //this.getdupdetails();
      }
  }

  dellibtsad(rid) {
    this.liservice.dellibtsad(rid)
        .subscribe(
        resultArray => {
            console.log('arrlibtsah', resultArray);
            //this.arrlibtsad = resultArray;
            alert(resultArray.message);
            this.getdetails();
            this.getdupdetails();
           
        },
        error => console.log("Error :: " + error)
        )
  }


  exportbookmas(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expauditresults.php?clcd="+clcd+"&aycd="+aycd+"&said="+this.rsaid+"&status="+this.status;
  
     window.open(url,'','');
   }

   exportrecorded(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expauditrecorded.php?clcd="+clcd+"&aycd="+aycd+"&said="+this.rsaid;
  
     window.open(url,'','');
   }

  applybooksFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      debugger
   
    this.searchdetails();
  }
  else 
  {
    this.getdetails();
  }
  
  }
  

  getresultdetails() {
    this.liservice.getlibtsar(this.rsaid,this.status)
        .subscribe(
        resultArray => {
            console.log('arrlibtsar', resultArray);
            this.arrlibtsar = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibaccesiontype() 
  {
  
    this.liservice.getlibaccesiontype()
        .subscribe(
        resultArray => {
            console.log('getlibaccesiontype', resultArray);
            this.acctypes = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  savelibtsar()
  {
    debugger
//console.log('objregdata',this.objstmhead);
//ar obj={alaccstatus:this.accno,said:this.rsaid,rid:0};
this.liservice.savelibtsar(this.objres)
.subscribe((result:any) => {

  alert (result.message);
console.log('arrinst',result);

if(result.status=='Success')
{
  let localmodref=this.modalRef;
  localmodref.close();
  this.getresultdetails();

}
else
{

}
}, error => {


}
);
  
  }


  processlibtsar()
  {
    debugger
//console.log('objregdata',this.objstmhead);
if(confirm("Are you sure you want to Process ?\nNote:All Previous Data will be Wiped Out. "))
{
var obj={said:this.rsaid,rid:0};
this.liservice.processlibtsar(obj)
.subscribe((result:any) => {

  alert (result.message);
console.log('arrinst',result);

if(result.status=='Success')
{
 
  this.getresultdetails();

}
else
{

}
}, error => {


}
);
}
  }

}

